/*
---
description: FED Process
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var _ada_ = {};

var Core = new Class();
Core.extend
({
	id_to_page: function(id){
		if(!id || id == '') return 'Page';

		return 'Page.' + id.trim().capitalize();
	},

	isFocusOutFromParent: function(event, parent) {
		const {target, relatedTarget} = event;

		if(!target || !relatedTarget)
			return;

		if(parent.contains(relatedTarget))
			return false;
		return true;
	},

	adaUtility: {
		// last resort for popup trigger
		// if they are not specified
		setTriggerForPopup: function(trigger) {
			_ada_.trigger = trigger;
		},

		getTriggerForPopup: function() {
			return _ada_.trigger;
		},

		// return handle close
		associateToggleAndDropdown: function(toggle, dropdown) {
			var id = dropdown.getAttribute('id');
			if(!id) {
				id =  Core.uuid();
				dropdown.setAttribute('id', id);
			}
			toggle.setAttribute('aria-controls', id);

			return {
				onOpen: () => toggle.setAttribute('aria-expanded', true),
				onClose: () => toggle.removeAttribute('aria-expanded')
			}
		}
	},


	// for modals
	// when modal is open, we dont allow uer to tab outside of the content
	disableTabbingOutside: function(element, hideFnc) {
		if(!element)
			return;
		const handleKeydown = event => {
			const tabElementsNodelist = element.querySelectorAll('a, button, input');
			let tabElements = [].slice.call(tabElementsNodelist);
			tabElements = tabElements.filter(d => {
				return d.getAttribute('disabled') !== 'disabled' && d.offsetParent !== null
			});
			if (event.ctrlKey || event.metaKey || event.altKey){
				return;
			}

			switch (event.which) {
				case 27:
					hideFnc && hideFnc();
					event.preventDefault();
					break;
				case 9:
					if (event.shiftKey) {
						if (document.activeElement === tabElements[0]) {
						tabElements[tabElements.length - 1].focus();
						event.preventDefault();
						}
					} else {
						if (document.activeElement === tabElements[tabElements.length - 1]) {
							tabElements[0].focus();
							event.preventDefault();
						}
					}
				break;
			}
		}

		element.addEventListener('keydown', handleKeydown);
		// return clear function so we can remove it when the element gets unmounted
		return () => element.removeEventListener('keydown', handleKeydown);
	},

	uuid: function() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/x|y/g, function(xy) {
			var r = Math.floor(Math.random()*16);
			return (xy === 'x' ? r : (r & 3 | 8)).toString(16);
		});
	},

	handleSkipToContent: function() {
		var ele = document.querySelector('.skip-to-content');
		ele.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var target = document.querySelector('#skip-to-content');
			target.focus();
		})
	},

	to_mobile_link: function() {
		// Check back to mobile link
		var _btn_to_mobile = $(document.body).getElement('#view-on-mobile');
		if (_btn_to_mobile) {
			_btn_to_mobile.removeEvents().addEvent('click', function(ev) {
				ev.preventDefault();
				Cookie.dispose("device-mode");
				if ($(document.body).getAttribute('data-has-mobile-view') == "0") {
					location.href = "/";
				} else {
					location.href = location.href;
				}
			});
		}
	},

	out: function(message){

	},

	track_g_tag: function() {
		var tagVersion = Cookie.read('crTrackGtag');
		if (tagVersion) {
			var to = "";
			switch (tagVersion) {
			case 'adwordsA':
				to = 'AW-1070970000/kITtCJXCjXgQkOnW_gM';
				break;
			case 'adwordsB':
				to = 'AW-1070970000/xeq8CIvEjXgQkOnW_gM';
				break;
			case 'adwordsC':
				to = 'AW-1070970000/YfhKCO7vpXgQkOnW_gM';
				break;
			case 'adwordsD':
				to = 'AW-1070970000/GpfnCIjEjXgQkOnW_gM';
				break;
			default:
				to = '';
			}
			gtag('event', 'conversion', {'send_to': to});
			Cookie.dispose('crTrackGtag');
		}
	},

	add_encrypted_link: function(el) {
		el.addEvent('click', function(){
			var decrypted = this.get('data-decrypted');
			if(decrypted !== "") {
				this.set('text', decrypted);
			}
		});
	},

	make_vtcr: function(with_message){
		// Create embed standalone Virtual Tour
		var _vtcr = document.getElement('.w_vtcr');

		if(!_vtcr) return;

		new Vtcr(_vtcr, {
			idx: 0,
			with_message: (with_message)? with_message : false,
			onUpdate: function(){
				if(this.options.with_message){
					this.add_message();
				}
			}
		});
	},

	add_outsider_grabber: function(){
		var	_content = document.getElement('.content_body') || document.getElement('.content_main');

		if(!_content) return;

		_content.getElements('.outsider, .page_title').each(function(_el){
			if (_el.hasClass('insider')){
				return;
			}

			_el.inject(_content, 'before');
		});
	},

	add_gallery_support: function(_el) {
		var _photogalleries = (_el? _el.getElements('.w_table_photogallery') : document.getElements('.w_table_photogallery'));

		_photogalleries.each(function(_e){
			new TablePhotogallery(_e);
		});
	},

	add_pricehistory_support: function(_el){
		var _pricehistory = (_el? _el.getElements('.w_blimp_pricehistory') : document.getElements('.w_blimp_pricehistory'));

		_pricehistory.each(function(e){
			new BlimpExtPricehistory(e, {
				draggable: true,
				show_veil: true
			});
		});
	},

	add_contact_support: function(){
		var _links_email = document.getElements('.w_blimp_contact_us');

		_links_email.each(function(_el){
			new Blimp.Form(_el, {
				draggable: true,
				show_veil: true,
				onFormSuccess: function(context, data) {
					if (data && data.RPCFormReusableContact_FORMSUMMARY
						&& data.RPCFormReusableContact_FORMSUMMARY[0]
						&& data.RPCFormReusableContact_FORMSUMMARY[0].status === true
						&& data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
						crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
					}
				}
			});
		});
	},

	add_mailing_list_support: function(){
		var _links_email = document.getElements('.w_blimp_mail_list');

		_links_email.each(function(_el){
			new Blimp.Form(_el, {
				draggable: true,
				show_veil: true,
				onFormSuccess: function(context, data) {
					if (data && data.RPCFormReusableContact_FORMSUMMARY
						&& data.RPCFormReusableContact_FORMSUMMARY[0]
						&& data.RPCFormReusableContact_FORMSUMMARY[0].status === true
						&& data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
						crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
					}
				}
			});
		});
	},

	add_subscribe_support: function(){
		var _links_subscribe = document.getElements('.w_blimp_subscribe');

		_links_subscribe.each(function(_el){
			new BlimpExt(_el, {
				draggable: true,
				show_veil: true,
				onHide: function(){
					if(!this._element.getElement('h3._error')){
						_el.dispose();
					}
				}
			});
		});
	},

	add_equal_height_support: function(){
		var _equal_height = document.getElements('.equal_height');

		_equal_height.each( function(e){
			new EqualHeight(e);
		});
	},

	add_tabset_support: function(){
		var _tabsets = document.getElements('.w_tabset');

		_tabsets.each(function(e){
			new Tabset(e);
		});
	},

	add_checkbox_click_support: function(_checkboxset){
		_checkboxset.addEvents({
			'mouseenter:relay(li label)': function(event, entered){
				entered.removeProperty('for');
			},

			'click:relay(li label)': function(e, clicked){
				if(e && e.stop) e.stop();

				var _checkbox = clicked.getParent().getElement('input');
				_checkbox.click();
			}
		});
	},

	add_article_support: function(){
		var _article = document.getElement('.wysiwyg.article');

		if(_article){
			var _imgs = _article.getElements('img');
			var _brs = _article.getElements('br');
		}

		if(_imgs){
			var _ps = _article.getElements('p'),
					_parent;

			//_imgs.reverse();
			_imgs.each(function(_img, i){

				if(_ps.length == 1)
					_parent = _img.getParent();
				else
					_parent = _article;

				_img.dispose();

				var _border = new Element('div', {'class': 'img_border'}),
						width =	_img.getProperty('width');

				if(width)
					_border.setStyle('width', width);

				if(_img.getProperty('align') == 'right')
					_border.setStyles({'float': 'right', 'margin': '0 0 10px 10px'});
				else
					_border.setStyles({'float': 'left', 'margin': '0 10px 10px 0'});

				_img.inject(_border);

				if(i == 0){
					_border.inject(_parent, 'top');
				}
				else{
					_brs.each(function(_br, i){
						if(i == 9){
							_border.inject(_br, 'after');
						}
					})
				}
			});
		}
	},


	add_stalker_support: function(options){
		window.Stalker_instance = new Stalker(options);
	},

	add_side_search_miniquest:function(){
		new SideSearch();
	},

	add_columns_support: function(){
		var _columns = document.getElements('.w_columns .idx_col');

		if(_columns && _columns.length > 0){
			new Rater(_columns, {
				'property': 'data-value',
				'size': 'absolute',
				'animate': true,
				'type': 'vertical',
				'duration': 1500,
				'equal_speed': true,
				'transition': Fx.Transitions.Bounce.easeOut
			});
		}
	},

	add_select_support: function(_cont){
		_cont = _cont || document;
		var _selects = _cont.getElements('.w_styled_select');

		_selects.each(function(_el){
			new StyledSelect(_el);
		});
	},

	add_signin_support: function(){

		var _signin_links = document.getElements('.w_blimp_signin');

		_signin_links.each(function(_el){
			new Blimp.Form(_el, {
				draggable: true,
				onFormSuccess: function(context, data) {
					if (data && data.RPCFormReusableContact_FORMSUMMARY
						&& data.RPCFormReusableContact_FORMSUMMARY[0]
						&& data.RPCFormReusableContact_FORMSUMMARY[0].status === true
						&& data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
						crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
					}
				}
			});
		});
	},
	add_signout_support: function(_el){
		//call blimp with signout view
		var sign_out = new BlimpExtSignOut(_el.getElement('.w_blimp_sign_out_box'),{
			'onShow' : function(data){
				Core.stop_window_scroll();
			},
			'onHide': function(){
				Core.resume_window_scroll();
			},
			'onBeforeShow': function(){
				document.getElement('.w_blimp_sign_out_box .links .button._raquo').removeEvents().addEvent('click', function(e){
					if(e && e.stop) e.stop();
					sign_out.hide();
				});
			},
			draggable: true,
			scrollable: false,

		});
	},

	add_signup_link: function(_el){
		// Fire GLOBAL event (jquery and mootools)
		var event;
		if (document.createEvent) {
			event = document.createEvent("HTMLEvents");
			event.initEvent("addRegLink", true, true);
		} else {
			event = document.createEventObject();
			event.eventType = "addRegLink";
		}

		event.eventEl = _el;

		if (document.createEvent) {
			document.dispatchEvent(event);
		} else {
			document.fireEvent("on" + event.eventType, event);
		}
	},

	stop_window_scroll: function(){
		var keys = [32, 33, 34, 35, 36, 37, 38, 39, 40];

		this.window_scroll_events = this.window_scroll_events || {
			'mousewheel': function(e){
				e.preventDefault();
			},

			'keydown': function(e){
				var tag = e.target.tagName.toLowerCase();

				if(keys.indexOf(e.code) >= 0 && tag != 'input' && tag != 'textarea'){
					e = e || window.event;
					if (e.preventDefault) e.preventDefault();

					e.returnValue = false;
				}
			}
		};

		$(document.body).addEvents(this.window_scroll_events);

		if(typeof Signup_blimp !== 'undefined' && (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android')){
			Signup_blimp._element.setStyles({
				'top': 20,
				'left': 60
			});

			document.body.setStyles({
				'height': Math.max(window.getSize().y + 70, Signup_blimp._element.getSize().y + 40),
				'overflow': 'hidden'
			});
		}
	},

	scrollToTargetAdjusted: function(element, offset){
		var elementPosition = element.getBoundingClientRect().top;
		var offsetPosition = elementPosition - offset;

		window.scrollTo({
			 top: offsetPosition,
			 behavior: "smooth"
		});
	},

	resume_window_scroll: function(){
		if(!this.window_scroll_events) return;

		document.body.removeEvents(this.window_scroll_events);

		if(typeof Signup_blimp !== 'undefined' && (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android')){
			document.body.setStyles({
				'height': 'auto',
				'overflow': 'hidden'
			})
		}
	},

	add_blimp_forms: function(){
		document.getElements('.w_blimp_form').each(function (_el) {
			var replace_by_result = _el.get('data-replace-by-result');
			var action = _el.get('data-action') || '';
			var label = _el.get('data-label') || '';
			new Blimp.Form(_el, {
				draggable: true,
				show_veil: true,
				replace_by_result : (replace_by_result && replace_by_result == 'true')? true : false,
				action: action,
				label: label
			});
		});
	},

	add_anchornator_support: function(els){
		new Anchornator(els);
	},

	add_scroll_support: function(){
		document.getElements('.w_styled_scroll').each(function(_el){
			new StyledScroll(_el, {type: 'v'});
		});
	},

	add_form_support: function(_form, on_submit, native_submit, category, action, label){
		if(!_form || _form.supported) return;

		var validation = !_form.getAttribute('data-validation') || _form.getAttribute('data-validation').toInt() == 1;
		category = category || window.pageType;
		action = action || _form.getAttribute('data-action');
		label = label || _form.getAttribute('data-label');
		new FormSupport(_form, {
			validation: validation,
			native_submit: (native_submit != undefined)? native_submit : true,
			category: category,
			action: action,
			label: label,
			onSubmit: function(e, is_valid){
				if(on_submit && typeOf(on_submit) == 'function'){
					on_submit();

					return is_valid || false;
				}
			}
		});
	},

	add_select_switcher_support: function(_select){
		_select.addEvent('change', function(){
			var _option = _select.getElement(':selected'),
					url = _select.getProperty('data-url'),
					option = _option.getProperty('value');

			window.location = url + option;
		});
	},

	add_bars_support: function(_container){
		_container = _container || document;

		_container.getElements('.w_bars').each(function(_el){
			if (_el.Picks) return;

			_el.Picks = new Picks(_el, {
				'item_class': 'w_bars_item'
			});
		});
	},

	add_video_popups_support: function(_container){
		_container = _container || document;

		_container.getElements('.w_blimp.video_link').each(function(_el){
			var blimp = new BlimpExt(_el, {
				draggable: true,
				onBeforeShow: function(){
					var _blimp_body = blimp._element.getElement('.w_popup_body');
					var _video_container = _blimp_body.getElement('.video_container');

					if(!_blimp_body._vc && _video_container){
						var id = 'vimeo_' + Math.floor((Math.random() * 1000) + 1);

						var _vc = new Element('div', {
							'html': '<iframe id="' + id + '" src="' + ('https:' == document.location.protocol ? 'https://' : 'http://') + 'player.vimeo.com/video/' + _blimp_body.getAttribute('data-vimeo-id') + '?api=1&player_id=' + id + '" width="730" height="410" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
						});

						_video_container.adopt(_vc);

						_blimp_body._vc = _vc;
					}
				}
			});
		});
	},

	add_footer_support: function(){
		if(!Core.is_touch_supported()) return;

		var _footer = document.id('footer');
		var _tooltips = (_footer)? _footer.getElements('.tooltip') : '';

		if(_tooltips.length > 0){
			_tooltips.each(function(_tooltip){
				_tooltip.dispose();
			});
		}


	},

	add_broker_toggle_support: function(){
		document.getElements('.user_menu .broker_item a').each(function(_el){
			_el.addEvents({
				'click': function(e){
					e.stop();

					var _parent = _el.getParent('._active');

					if(_parent){
						_parent.removeClass('_active');
					}


					Cookie.write('broker_view', _el.getAttribute('data-view'), {duration: 0});
					window.location = window.location;
				}
			});
		});
	},

	add_dropdownmenu_support: function(){
		var _dropdownmenu = document.getElement('.w_dropdownmenu');

		if(_dropdownmenu){
			new DropdownMenu();
		}
	},

	add_img_lazyloader: function(){
		new ImgLazyLoad({
			container: document.getElement('.w_divtable'),
			elements: '.imagestrip._lazy',
			range: 200
		});
	},

	add_commas: function(nStr){
		nStr += '';
		var x = nStr.split('.');
		var x1 = x[0];
		var x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2');
		}
		return x1 + x2;
	},

	get_html_text: function(text){
		if(!text) return;
		var stub_object = new Element('span',{'html': text});
		var ret_val = stub_object.get('text');
		stub_object.destroy();

		return ret_val;
	},

	make_rating_hover: function() {
		var _rating = document.getElement('.w_rating');
		if (!_rating) {
			return;
		}
		this.fxs = [];
		this.timers = [];
		_rating.addEvents({
			click: function(){
				var url = _rating.getProperty('href');

				if(url && url != ''){
					window.location = url;
				}
			},
			mouseenter: function() {
				if (!this.fxs.length) {
					var _types = _rating.getElements('.w_rating_type');
					_types.each(function(_type) {
						_type.setStyles({
							opacity: 0,
							visibility: 'visible'
						});
						this.fxs.push(new Fx.Morph(_type, {
							link: 'cancel'
						}));
					}.bind(this));
				}
				this.fxs.each(function(fx, i) {
					this.timers.push((function() {
						fx.start({
							opacity: [0, 1]
						});
					}).delay(i*200, this));
				}.bind(this));

			}.bind(this),
			mouseleave: function() {
				this.timers.each(function(timer) {
					clearInterval(timer);
				});
				this.fxs.each(function(fx, i) {
					fx.cancel();
					fx.set({
						opacity: 0
					});
				});
			}.bind(this)
		})
	},

	load_google_api: function(onload_function, el){
		if(GoogleApiLoad == 'loaded'){
			if(onload_function) onload_function();

			return;
		}else if(GoogleApiLoad == 'wait'){
			(function(){
				this.load_google_api(onload_function);
			}.bind(this)).delay(50);

			return;
		}

		GoogleApiLoad = 'wait';

		this.u_cb_id = 'map_onload_callback_' + String.uniqueID();
		window[this.u_cb_id] = function(){
			if(onload_function) onload_function();

			if (window[this.u_cb]){
				delete window[this.u_cb];
			}

			delete this.u_cb_id;
		}.bind(this);

		var api = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'maps.google.com/maps/api/js?' +
								'key=' + window['GOOGLE_API_key'] + '&' +
								'libraries=visualization,geometry&' +
								'v=3&' +
								'other_params=client&' +
								'callback=' + this.u_cb_id;

		new Asset.javascript(api, {
			'onLoad': function(){
				GoogleApiLoad = 'loaded';
			}.bind(this)
		});
	},

	get_window_size: function(){
		var w = window,
				d = document,
				e = d.documentElement,
				g = d.getElementsByTagName('body')[0];

		return{
			'x': w.innerWidth || e.clientWidth || g.clientWidth,
			'y': w.innerHeight|| e.clientHeight|| g.clientHeight
		}
	},

	add_clear: function(el, loc)
	{
		var location = $pick(loc, 'bottom');
		return new Element('div', { "class": "g_clear" }).inject(el, location);
	},
	add_ie_cache: function()
	{
		if (Browser.Engine.trident)
			document.execCommand("BackgroundImageCache",false,true);
	},
	get_ext_path: function()
	{
		return Gv.url.ext+'/{Klass}.js';
	},
	to_url: function(url)
	{
		window.location = url;
	},

	is_visible: function(obj){
		if(!obj) return false;

		if(obj == document) return true;

		if(!obj.parentNode) return false;

		if(obj.style){
			if(obj.style.display == 'none') return false;
			if(obj.style.visibility == 'hidden') return false;
		}
		var style;
		//Try the computed style in a standard way
		if(window.getComputedStyle) {
			style = window.getComputedStyle(obj, "");

			if(style.display == 'none') return false;
			if(style.visibility == 'hidden') return false;
		}

		//Or get the computed style using IE's silly proprietary way
		style = obj.currentStyle;

		if(style){
			if(style['display'] == 'none') return false;
			if(style['visibility'] == 'hidden') return false;
		}

		return this.is_visible(obj.parentNode);
	},

	destruct: function(obj, scope) {
		if (!obj) { return; }
		scope = scope || window;
		var name = Object.keyOf(scope, obj);
	 	if(scope[name]){
	 		try {
		 		delete scope[name];
	 		} catch (er) { scope[name] = null; }
	 	}
	},

	supports_flash: function(){
		try {
		  var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
		  if(fo) return true;
		}catch(e){
		  if(navigator.mimeTypes ["application/x-shockwave-flash"] != undefined) return true;
		}

		return false;
	},

	set_session_data: function(container_name, value){
		Core.check_localStorage_capacity();

		try {
			localStorage.setItem(container_name, JSONMOO.encode(value));
		} catch(e) {
      return false;
    }
	},

	get_session_data: function(container_name){
		var data = JSONMOO.decode(localStorage.getItem(container_name), false);

		return data;
	},

	remove_session_data: function(id){
		Object.each(localStorage, function(data, key){
			if(key.contains(id)){
				localStorage.removeItem(key);
			}
		})
	},

	get_oldest_session_data_id: function(){
		var oldest_data_id, oldest_date;

		Object.each(localStorage, function(data, key){
			if(key.contains('data-store-date')){
				if(!oldest_date || oldest_date > data.toInt()){
					oldest_date = data.toInt();
					oldest_data_id = key.split('data-store-date-').join('');
				}
			}
		});

		return oldest_data_id;
	},

	check_localStorage_capacity: function(){
		if(!Core.is_localStorage_available()){
			var id = Core.get_oldest_session_data_id();

			if(id) Core.remove_session_data(id);
		}
	},

	bottom_bar: (triggerElement, offset) => {
		let bottomBar = document.getElement('.bottom-bar');

		window.addEvents({
			'scroll' : (e) => {
				// if there is a tour expert
				if (bottomBar) {
					if (window.scrollY > triggerElement.getPosition().y - window.screen.height + offset) {
						bottomBar.removeClass('none');
					} else {
						bottomBar.addClass('none');

					}
				}
			}
		});
	},

	is_localStorage_available: function(){
		var total = 0;
		var limit = 4;// localStorage has 5mb capacity only

		Object.each(localStorage, function(data, key){
			var amount = (data.length * 2) / 1024 / 1024;
		  total += amount;
		});

		total = total.toFixed(2);

		return (total >= limit? false : true);
	},

	get_previous_page_id: function(){
		var previous_page_id = Cookie.read('crPreviousPage');

		Cookie.write('crPreviousPage', $(document.body).get('id'));

		return previous_page_id;
	},

	clear_sales_data_cookies: function(){
		if($(document.body).get('id') == 'lst' || document.getElement('.w_sales_data')) return;

  	Cookie.dispose('salesDataType');
		Cookie.dispose('salesDataRegion');
		Cookie.dispose('salesDataCurrency');
		Cookie.dispose('salesDataPeriod');
		Cookie.dispose('salesDataPriceRange');
		Cookie.dispose('salesDataBeds');
	},

	shake_element: function(_el, prop){
		if(!_el) return;

		if(!_el.shake){
      _el.shake = new Fx.Morph(_el, {
        link: 'cancel'
      });
    }

    _el.shake.options.duration = 50;
    _el.shake.options.transition = Fx.Transitions.linear.easeOut;

    var options = {};

    options[prop || 'margin-left'] = -20;

    _el.shake.start(options).chain(function(){
      _el.shake.options.duration = 1000;
      _el.shake.options.transition = Fx.Transitions.Elastic.easeOut;

			options[prop || 'margin-left'] = 0;

      _el.shake.start(options);
    });
	},

	add_froogaloop: function(){
		if(window.Froogaloop) return;
		/*function is modified!!!!
		window.addEventListener('message') was removed because of error.
		get full version on https://github.com/vimeo/player-api/blob/master/javascript/froogaloop.js
		*/
		(function(){
		    // Define a local copy of Froogaloop
		    function Froogaloop(iframe) {
		        // The Froogaloop object is actually just the init constructor
		        return new Froogaloop.fn.init(iframe);
		    }

		    var eventCallbacks = {},
		        isReady = false,
		        playerOrigin = '*';

		    Froogaloop.fn = Froogaloop.prototype = {
		        element: null,

		        init: function(iframe) {
		            if (typeof iframe === "string") {
		                iframe = document.getElementById(iframe);
		            }

		            this.element = iframe;

		            return this;
		        },

		        /*
		         * Calls a function to act upon the player.
		         *
		         * @param {string} method The name of the Javascript API method to call. Eg: 'play'.
		         * @param {Array|Function} valueOrCallback params Array of parameters to pass when calling an API method
		         *                                or callback function when the method returns a value.
		         */
		        api: function(method, valueOrCallback) {
		            if (!this.element || !method) {
		                return false;
		            }

		            var self = this,
		                element = self.element,
		                target_id = element.id !== '' ? element.id : null,
		                params = !isFunction(valueOrCallback) ? valueOrCallback : null,
		                callback = isFunction(valueOrCallback) ? valueOrCallback : null;

		            // Store the callback for get functions
		            if (callback) {
		                storeCallback(method, callback, target_id);
		            }

		            postMessage(method, params, element);
		            return self;
		        },

		        /*
		         * Registers an event listener and a callback function that gets called when the event fires.
		         *
		         * @param eventName (String): Name of the event to listen for.
		         * @param callback (Function): Function that should be called when the event fires.
		         */
		        addEvent: function(eventName, callback) {
		            if (!this.element) {
		                return false;
		            }

		            var self = this,
		                element = self.element,
		                target_id = element.id !== '' ? element.id : null;


		            storeCallback(eventName, callback, target_id);

		            // The ready event is not registered via postMessage. It fires regardless.
		            if (eventName != 'ready') {
		                postMessage('addEventListener', eventName, element);
		            }
		            else if (eventName == 'ready' && isReady) {
		                callback.call(null, target_id);
		            }

		            return self;
		        },

		        /*
		         * Unregisters an event listener that gets called when the event fires.
		         *
		         * @param eventName (String): Name of the event to stop listening for.
		         */
		        removeEvent: function(eventName) {
		            if (!this.element) {
		                return false;
		            }

		            var self = this,
		                element = self.element,
		                target_id = element.id !== '' ? element.id : null,
		                removed = removeCallback(eventName, target_id);

		            // The ready event is not registered
		            if (eventName != 'ready' && removed) {
		                postMessage('removeEventListener', eventName, element);
		            }
		        }
		    };

		    /**
		     * Handles posting a message to the parent window.
		     *
		     * @param method (String): name of the method to call inside the player. For api calls
		     * this is the name of the api method (api_play or api_pause) while for events this method
		     * is api_addEventListener.
		     * @param params (Object or Array): List of parameters to submit to the method. Can be either
		     * a single param or an array list of parameters.
		     * @param target (HTMLElement): Target iframe to post the message to.
		     */
		    function postMessage(method, params, target) {
		        if (!target.contentWindow.postMessage) {
		            return false;
		        }

		        var data = JSON.stringify({
		            method: method,
		            value: params
		        });

		        target.contentWindow.postMessage(data, playerOrigin);
		    }




		    /**
		     * Stores submitted callbacks for each iframe being tracked and each
		     * event for that iframe.
		     *
		     * @param eventName (String): Name of the event. Eg. api_onPlay
		     * @param callback (Function): Function that should get executed when the
		     * event is fired.
		     * @param target_id (String) [Optional]: If handling more than one iframe then
		     * it stores the different callbacks for different iframes based on the iframe's
		     * id.
		     */
		    function storeCallback(eventName, callback, target_id) {
		        if (target_id) {
		            if (!eventCallbacks[target_id]) {
		                eventCallbacks[target_id] = {};
		            }
		            eventCallbacks[target_id][eventName] = callback;
		        }
		        else {
		            eventCallbacks[eventName] = callback;
		        }
		    }



		    function removeCallback(eventName, target_id) {
		        if (target_id && eventCallbacks[target_id]) {
		            if (!eventCallbacks[target_id][eventName]) {
		                return false;
		            }
		            eventCallbacks[target_id][eventName] = null;
		        }
		        else {
		            if (!eventCallbacks[eventName]) {
		                return false;
		            }
		            eventCallbacks[eventName] = null;
		        }

		        return true;
		    }

		    function isFunction(obj) {
		        return !!(obj && obj.constructor && obj.call && obj.apply);
		    }

		    function isArray(obj) {
		        return toString.call(obj) === '[object Array]';
		    }

		    // Give the init function the Froogaloop prototype for later instantiation
		    Froogaloop.fn.init.prototype = Froogaloop.fn;

		    // Expose froogaloop to the global object
		    return (window.Froogaloop = window.$f = Froogaloop);

		})();
	},

	add_autoplay_support: function(){
		var _iframes =  document.getElements('.w_bars_item iframe');

    if(_iframes && _iframes.length > 0){

    	_iframes.each(function(_iframe){
    		_iframe.set('src', _iframe.get('src') + '&autoplay=1&loop=1');
    	})
    }
	},

	clean_url: function(dirty){
		if(!dirty) return;

		var first_char = dirty.substr(0, 1);
		var last_char = dirty.substr(dirty.length-1, 1);
		var clean = dirty;

		if (first_char == '#') {
			clean = clean.substr(1, clean.length-1);
		}

		if (last_char == '?') {
			clean = clean.substr(0, clean.length-1);
		}

		return clean;
	},

	stick_building_last_ads: function(elementClass) {
		var self = this;
		var _content_aside = document.getElement('.content_aside') || document.getElement('.aside_ad');
		if (!_content_aside) return;

		var _side_contact = document.getElement('.' + elementClass);
		var _sticky_content = _side_contact ? document.getElement('.sticky-content') : null;

		var stalker = document.getElement('.w_stalker');
		var contentBody1 = document.getElement('.content_body_1');
		var contentBody1_1 = document.getElement('.content_body_1_1');
		var contentBody2 = document.getElement('.content_body_2');
		var contentBody3 = document.getElement('.content_body_3');
		var contentAside1 = document.getElement('.content_aside_1');
		var contentAside2 = document.getElement('.content_aside_2');
		var contentAside3 = document.getElement('.content_aside_3');

		var stalkerHeight = (stalker ? stalker.getSize().y : 0) + 20;

		var flags1 = {
			fixOrStick: false
		};
		var flags2 = {
			fixOrStick: false
		};
		var flags3 = {
			fixOrStick: false
		};

		window.addEvents({
			'scroll' : function(e) {
				var scrollTop = window.getScrollTop();

				// scroll contact form
				if (_sticky_content) {
					var stickyPoint1 = contentAside1.querySelector('.sticky-point');
					self.scroll_content(_sticky_content, stickyPoint1, contentBody1, flags1, stalkerHeight, scrollTop, 'bov_contactform', contentBody1_1);
				}

				// scroll ads
				var adsAside1 = contentAside1 ? contentAside1.querySelectorAll('.w_pub') : null;
				if (adsAside1 && adsAside1.length) {
					var lastAdAside1 = adsAside1[adsAside1.length - 1];
				}
				if (lastAdAside1) {
					var stickyPoint1 = contentAside1.querySelector('.sticky-point');
					self.scroll_content(lastAdAside1, stickyPoint1, contentBody1, flags1, stalkerHeight, scrollTop, 'bov_side_1_last_ad');
				}

				var adsAside2 = contentAside2 ? contentAside2.querySelectorAll('.w_pub') : null;
				if (adsAside2 && adsAside2.length) {
					var lastAdAside2 = adsAside2[adsAside2.length - 1];
				}
				if (lastAdAside2) {
					var stickyPoint2 = contentAside2.querySelector('.sticky-point');
					self.scroll_content(lastAdAside2, stickyPoint2, contentBody2, flags2, stalkerHeight, scrollTop, 'bov_side_2_last_ad');
				}

				var adsAside3 = contentAside3 ? contentAside3.querySelectorAll('.w_pub') : null;
				if (adsAside3 && adsAside3.length) {
					var lastAdAside3 = adsAside3[adsAside3.length - 1];
				}
				if (lastAdAside3) {
					var stickyPoint3 = contentAside3.querySelector('.sticky-point');
					if (stickyPoint3) {
						self.scroll_content(lastAdAside3, stickyPoint3, contentBody3, flags3, stalkerHeight, scrollTop, 'bov_side_3_last_ad');
					}
				}
			}
		});
	},

	stick_building_review_last_ads: function(elementClass) {
		var self = this;
		var _content_aside = document.getElement('.content_aside') || document.getElement('.aside_ad');
		if (!_content_aside) return;

		var _side_contact = document.getElement('.' + elementClass);
		var _sticky_content = _side_contact ? document.getElement('.sticky-content') : null;

		var stalker = document.getElement('.w_stalker');
		var contentBody1 = document.getElement('.content_body_1');
		var contentBody2 = document.getElement('.content_body_2');
		var contentBody3 = document.getElement('.content_body_3');
		var contentAside1 = document.getElement('.content_aside_1');
		var contentAside2 = document.getElement('.content_aside_2');
		var contentAside3 = document.getElement('.content_aside_3');

		var stalkerHeight = (stalker ? stalker.getSize().y : 0) + 20;

		var flags1 = {
			fixOrStick: false
		};
		var flags2 = {
			fixOrStick: false
		};
		var flags3 = {
			fixOrStick: false
		};

		window.addEvents({
			'scroll' : function(e) {
				var scrollTop = window.getScrollTop();

				// scroll contact form
				if (_sticky_content) {
					var stickyPoint1 = contentAside1.querySelector('.sticky-point');
					self.scroll_content(_sticky_content, stickyPoint1, contentBody1, flags1, stalkerHeight, scrollTop, 'contactform');
				}

				// scroll ads
				var adsAside1 = contentAside1 ? contentAside1.querySelectorAll('.w_pub') : null;
				if (adsAside1 && adsAside1.length) {
					var lastAdAside1 = adsAside1[adsAside1.length - 1];
				}
				if (lastAdAside1) {
					var stickyPoint1 = contentAside1.querySelector('.sticky-point');
					self.scroll_content(lastAdAside1, stickyPoint1, contentBody1, flags1, stalkerHeight, scrollTop, 'side_1_last_ad');
				}

				var adsAside2 = contentAside2 ? contentAside2.querySelectorAll('.w_pub') : null;
				if (adsAside2 && adsAside2.length) {
					var lastAdAside2 = adsAside2[adsAside2.length - 1];
				}
				if (lastAdAside2) {
					var stickyPoint2 = contentAside2.querySelector('.sticky-point');
					self.scroll_content(lastAdAside2, stickyPoint2, contentBody2, flags2, stalkerHeight, scrollTop, 'side_2_last_ad');
				}

				var adsAside3 = contentAside3 ? contentAside3.querySelectorAll('.w_pub') : null;
				if (adsAside3 && adsAside3.length) {
					var lastAdAside3 = adsAside3[adsAside3.length - 1];
				}
				if (lastAdAside3) {
					var stickyPoint3 = contentAside3.querySelector('.sticky-point');
					self.scroll_content(lastAdAside3, stickyPoint3, contentBody3, flags3, stalkerHeight, scrollTop, 'side_3_last_ad');
				}
			}
		});
	},

	stick_last_ads_neighborhood: function() {
		var self = this;
		var stalker = document.getElement('.w_stalker');
		var contentBody1 = document.getElement('.content_body_1');
		var contentMain = contentBody1 ? contentBody1.getElement('.content_main') : null;
		var contentAside1 = document.getElement('.content_aside_1');

		var stalkerHeight = (stalker ? stalker.getSize().y : 0) + 20;

		var flags1 = {
			fixOrStick: false
		};

		if (contentBody1 && contentMain && contentAside1) {
			window.addEvents({
				scroll: function(e) {
					if (contentMain.getHeight() < contentAside1.getHeight()) {
						return;
					}
					var scrollTop = window.getScrollTop();

					// scroll ads
					var adsAside1 = contentAside1 ? contentAside1.querySelectorAll('.w_pub') : null;
					if (adsAside1 && adsAside1.length) {
						var lastAdAside1 = adsAside1[adsAside1.length - 1];
					}
					if (lastAdAside1) {
						var stickyPoint1 = contentAside1.querySelector('.sticky-point');
						self.scroll_content(lastAdAside1, stickyPoint1, contentBody1, flags1, stalkerHeight, scrollTop, 'neighborhood_ad');
					}
				}
			});
		}
	},

	scroll_content: function(stickyContent, stickyPoint, contentBody, flags, stalkerHeight, scrollTop, type, contentBody1_1) {
		var stickyPointTop = stickyPoint ? stickyPoint.getPosition().y - stalkerHeight: 0;
		var stickyContentHeight = stickyContent ? stickyContent.getHeight() : 0;
		var contentBodyBottom = contentBody ? contentBody.getPosition().y + contentBody.getHeight() - stickyContentHeight - stalkerHeight - 20 : 0;
		if (type == 'bov_contactform' && !!contentBody1_1) {
			contentBodyBottom += contentBody1_1.getHeight();
		}
		if (stickyContent && flags.fixOrStick && scrollTop < stickyPointTop) {
			if (flags.fixOrStick) {
				// var top = contentBody.getHeight() - stickyContentHeight - 10;
				stickyContent.setStyles({
					'position' : 'relative',
					'top' : 0,
					'left' : 'inherit'
				});
				flags.fixOrStick = false;
			}
		} else if (stickyContent && scrollTop >= stickyPointTop && scrollTop < contentBodyBottom) {
			stickyContent.setStyles({
				'position' : 'fixed',
				'top' : stalkerHeight,
				'left' : 'auto'
			});
			flags.fixOrStick = true;
		} else if (stickyContent && scrollTop >= contentBodyBottom) {
			var top = contentBody.getHeight() - stickyContentHeight - 10;
			if (type == 'bov_contactform' && !!contentBody1_1) {
				top += contentBody1_1.getHeight() - 50;
			}
			stickyContent.setStyles({
				'position' : 'absolute',
				'top' : top + 'px',
				'left' : 'auto'
			});
			flags.fixOrStick = true;
		}
	},
	
	changeBodyStyleOverflow: function(_content_aside, ev) {
		if ((_content_aside.hasClass('rent') || _content_aside.hasClass('content_aside_flex')) && !!_content_aside.getStyle('display') && _content_aside.getStyle('display') == 'flex') {
			function screenMaxWidthMatch(x) {
				if (x.matches) {
					if (!!document.body.getStyle('overflow') && document.body.getStyle('overflow') == 'hidden') {
						document.body.setStyles({'overflow': 'visible'});
					}
				}
			}
			  
			// Create a MediaQueryList object
			const mmObj = window.matchMedia("(max-width: 1630px)")
			  
			// Call the match function at run time:
			screenMaxWidthMatch(mmObj);
			  
			// Add the match function as a listener for state changes:
			mmObj.addListener(screenMaxWidthMatch);
		}
	},

	stick_last_ads: function() {
		var self = this;
		var _main_content = document.getElement('.content_main') || document.getElement('.cr_toggle_view');
		var _content_aside = document.getElement('.content_aside') || document.getElement('.aside_ad');
		if(!_content_aside) return;

		var _ad_container = _content_aside.getElement('.w_pub_container') || _content_aside;
		var _ads = _ad_container.getElements('.w_pub');
		var _stalker = document.getElement('.w_stalker');

		var _side_contact = document.getElement('.contact-component');
		var _sticky_content = _side_contact ?  document.getElement('.sticky-content') : null;
		var _sticky_section_anchor = _side_contact ? document.getElement('.building_section') || document.getElement('.estimated_monthly_cost') : null;

		var last_ad = _ads[_ads.length - 1];
		var footer = document.getElement('#footer');
		var stalker = document.getElement('.w_stalker');

		var stalkerHeight = (stalker ? stalker.getSize().y : 0) + 20;

		var newTopLastAd;
		var lastAdSticked = false;

		var topStickyContent = _sticky_content ? _sticky_content.getPosition().y - stalkerHeight : 0;
		var topStickySectionAnchor = _sticky_section_anchor ? _sticky_section_anchor.getPosition().y - stalkerHeight + 60: 0;
		var topLastAd = 0;

		var state = {
			'nothing-sticked': false,
			'stick-side-content': false,
			'inject-sticky-content': false,
			'stick-last-ad': false,
			'last-ad-end-container': false,
			'last-ad-bottom': false
		};

		window.addEvents({
			'load' : function(e) {
				self.changeBodyStyleOverflow(_content_aside, 'load');
			},
			'resize' : function(e) {
				self.changeBodyStyleOverflow(_content_aside, 'resize');
				if (lastAdSticked && last_ad && !last_ad.hasClass('bottom')) {
					last_ad.setStyles({
						'right' : window.getSize().x - (_ad_container.getBoundingClientRect().right)
					});
				}
			},
			'scroll' : function(e) {
				self.changeBodyStyleOverflow(_content_aside, 'scroll');
				var topFooter = footer.getPosition().y;

				// stop when the main content height is smaller than the ad section height
				if (_main_content.getSize().y < _content_aside.getSize().y) {
					return;
				}

				var lastAdHeight = last_ad ? last_ad.getHeight() : 0;
				var lastAdPosition = last_ad ? last_ad.getPosition().y : 0;
				var lastAdSize = last_ad && last_ad.getSize().x > 0 ? last_ad.getSize().x : 300;
				var bottomContentBodyStick = _main_content ? _main_content.getPosition().y + _main_content.getHeight() - lastAdHeight - stalkerHeight - 20 : 0;

				// readjust the section anchor position (when the page is loaded)
				topStickySectionAnchor = _sticky_section_anchor ? _sticky_section_anchor.getPosition().y - stalkerHeight + 60: 0;

				// if last ad is sticked, the top last ad will be the end of the content aside
				if (lastAdSticked) {
					if (_sticky_content) {
						topLastAd = _sticky_content.getPosition().y + _sticky_content.getBoundingClientRect().height;
					} else {
						topLastAd = _content_aside.getPosition().y + _content_aside.getBoundingClientRect().height;
					}
				}
				// else take the top of the last od
				else {
					newTopLastAd = lastAdPosition;
					if (newTopLastAd && newTopLastAd > topLastAd) {
						topLastAd = newTopLastAd;
					}
				}

				var topLastAdStick = topLastAd - stalkerHeight;

				// nothing sticked
				if (_sticky_content && window.getScrollTop() < topStickyContent) {
					if (!state['nothing-sticked']) {
						_sticky_content.setStyles({
							'position' : 'relative',
							'top' : 0,
							'right': 'inherit'
						});
						_sticky_content.inject(_content_aside);
						lastAdSticked = false;

						if (last_ad) {
							last_ad.setStyles({
								'position' : 'relative',
								'top' : 0,
								'right': 'inherit'
							});

							last_ad.removeClass('bottom');
							last_ad.inject(_ad_container);
							lastAdSticked = false;
						}
					}

					state = {
						'nothing-sticked': true,
						'stick-side-content': false,
						'inject-sticky-content': false,
						'stick-last-ad': false,
						'last-ad-end-container': false,
						'last-ad-bottom': false
					};
				}
				// stick side content
				else if (_sticky_content && window.getScrollTop() >= topStickyContent && window.getScrollTop() < topStickySectionAnchor) {
					if (!state['stick-side-content']) {
						if (_sticky_content) {
							_sticky_content.setStyles({
								'position' : 'fixed',
								'top' : (_stalker ? _stalker.getSize().y : 0) + 20,
								'right' : 'auto'
							});
							_sticky_content.inject(_content_aside);
						}
						lastAdSticked = false;

						if (last_ad) {
							last_ad.setStyles({
								'position' : 'relative',
								'top' : 0,
								'right': 'inherit'
							});

							last_ad.removeClass('bottom');
							last_ad.inject(_ad_container);
							lastAdSticked = false;
						}
					}

					state = {
						'nothing-sticked': false,
						'stick-side-content': true,
						'inject-sticky-content': false,
						'stick-last-ad': false,
						'last-ad-end-container': false,
						'last-ad-bottom': false
					};
				}
				// inject sticky content
				else if ( window.getScrollTop() >= topStickySectionAnchor && window.getScrollTop() < topLastAdStick) {
					if (!state['inject-sticky-content']) {
						if (_sticky_content && _sticky_section_anchor && !_sticky_section_anchor.querySelector('.sticky-content')) {
							_sticky_content.setStyles({
								'position' : 'absolute',
								'top' : '65px',
								'right' : -(lastAdSize + 28)
							});
							_sticky_content.inject(_sticky_section_anchor);
						}

						if (last_ad) {
							last_ad.setStyles({
								'position' : 'relative',
								'top' : 0,
								'right': 'inherit'
							});

							last_ad.removeClass('bottom');
							last_ad.inject(_ad_container);
							lastAdSticked = false;
						}
					}

					state = {
						'nothing-sticked': false,
						'stick-side-content': false,
						'inject-sticky-content': true,
						'stick-last-ad': false,
						'last-ad-end-container': false,
						'last-ad-bottom': false
					};
				}

				// stick last ad
				else if (window.getScrollTop() >= topLastAdStick && window.getScrollTop() < bottomContentBodyStick) {
					if (!state['stick-last-ad']) {
						if (_sticky_content  && _sticky_section_anchor && !_sticky_section_anchor.querySelector('.sticky-content')) {
							_sticky_content.setStyles({
								'position' : 'absolute',
								'top' : '60px',
								'right' : -(lastAdSize + 28)
							});
							_sticky_content.inject(_sticky_section_anchor);
						}

						if (last_ad) {
							last_ad.setStyles({
								'position' : 'fixed',
								'top' : (_stalker ? _stalker.getSize().y : 0) + 20,
								'right' : window.getSize().x - (_ad_container.getBoundingClientRect().right)
							});

							last_ad.removeClass('bottom');
							last_ad.inject(_ad_container);
							lastAdSticked = true;
						}
					}

					state = {
						'nothing-sticked': false,
						'stick-side-content': false,
						'inject-sticky-content': false,
						'stick-last-ad': true,
						'last-ad-end-container': false,
						'last-ad-bottom': false
					};
				}

				// insert last ad at the end of the container
				else if (window.getScrollTop() >= topLastAdStick && window.getScrollTop() >= bottomContentBodyStick) {
					if (!state['last-ad-end-container']) {
						if (_sticky_content && _sticky_section_anchor && !_sticky_section_anchor.querySelector('.sticky-content')) {
							_sticky_content.setStyles({
								'position' : 'absolute',
								'top' : '60px',
								'right' : -(lastAdSize + 28)
							});
							_sticky_content.inject(_sticky_section_anchor);
						}

						if (last_ad) {
							last_ad.addClass('bottom');
							last_ad.inject(_main_content);
							last_ad.setStyles({
								'right' : -(lastAdSize + 27)
							});

							lastAdSticked = true;
						}
					}

					state = {
						'nothing-sticked': false,
						'stick-side-content': false,
						'inject-sticky-content': false,
						'stick-last-ad': false,
						'last-ad-end-container': true,
						'last-ad-bottom': false
					};
				}

				// insert last ad at bottom page
				else if (window.getScroll().y + lastAdHeight + 120 >= topFooter) {
					if (!state['last-ad-bottom']) {
						if (_sticky_content && _sticky_section_anchor && !_sticky_section_anchor.querySelector('.sticky-content')) {
							_sticky_content.setStyles({
								'position' : 'absolute',
								'top' : '60px',
								'right' : -(lastAdSize + 28)
							});
							_sticky_content.inject(_sticky_section_anchor);
						}

						if (last_ad) {
							last_ad.addClass('bottom');
							last_ad.inject(_main_content);
							last_ad.setStyles({
								'right' : -(lastAdSize + 27)
							});

							lastAdSticked = true;
						}
					}

					state = {
						'nothing-sticked': false,
						'stick-side-content': false,
						'inject-sticky-content': false,
						'stick-last-ad': false,
						'last-ad-end-container': false,
						'last-ad-bottom': true
					};
				}
			}
		});
	},

	set_sticky_ads_to_normal: function(){
		var _content_aside = document.getElement('.content_aside') || document.getElement('.aside_ad');

		if (!_content_aside) return;

		var _ad_container = _content_aside.getElement('.w_pub_container') || _content_aside;
		var _last_ad = document.getElement('.w_pub.bottom');

		if(_last_ad){
			_last_ad.removeClass('bottom');
			_last_ad.inject(_ad_container);

			_last_ad.setStyles({
				'position' : 'relative',
				'right' : 'inherit',
				'left' : 'inherit',
				'top' : 0
			});
		}
	},

	short_number: function(number, decimal){
		if(number > 999444){
			return (number / 1000000).round(decimal) + 'M';
		}else if(number > 999){
			return (number / 1000).round(decimal) + 'K';
		}else{
			return number;
		}
	},

	capitalize: function (string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	},

	/**
	 * This function translate a param object into a string with get parameters
	 * The param object can contain single value and array
	 * @param  {Object} paramsObject Object to be translated
	 * @return {String} The string containing the get parameters
	 */
	param: function(paramsObject) {
		var paramsRpc = "";
		// add the list of params
		for(var key in paramsObject) {
			if (paramsObject.hasOwnProperty(key)) {
				// if param is an array add every value as param
				if (paramsObject[key].constructor.toString().indexOf('Array') > -1) {
					for(var i = 0; i < paramsObject[key].length; i++) {
						paramsRpc += "&" + key + "=" + paramsObject[key][i];
					}
				} else {
					// param is a single value
					paramsRpc += "&" + key + "=" + paramsObject[key];
				}
			}
		}
		return paramsRpc;
	},

	update_date_range_title: function() {
		try {
			if (Highcharts && Highcharts.RangeSelector) {
				Highcharts.RangeSelector.prototype.render = (function(func) {
						return function(){
							func.apply(this, arguments);

							this.zoomText.element.textContent = 'Date Range';
							this.zoomText.textStr = 'Date Range';
						}
				} (Highcharts.RangeSelector.prototype.render));
			}
		}
		catch(err) {}
	},

	get_daterange_min_date: function(type) {
		var min_date;
		//NCR-3485
		if (type === 'closedSales') {
			// For closed sales, the min date year start in the year 2003.
			min_date = '01/01/2003';
		} else {
			// For apartment for sales/rent, the minimum date year is 3yrs ago from the current date.
			min_date = '01/01/' + window.moment().subtract(3, 'years').format('YYYY').toString();
		}

		return new Date(min_date);
	},

	get_daterange_max_date: function() {
		var max_date = new Date;

		return max_date;
	},

	set_content_position: function() {
		var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		var __saveWidth = function(){
			screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			//save cookies to use it in header.php after page reload.
			Cookie.write('screenWidth', screenWidth);
		}

		window.addEvents({
			resize: function(){
				__saveWidth();
			},
			load: function(){
				__saveWidth();
				var page_content_wrapper = document.getElement('.page_content_wrapper');
				var minWidth = 1044 + 600; //1044 - min width of body; 600 - double width of sidesearch results bar
			}
		});
	},

	update_track_category: function(text) {
		if (text) {
			text = text.replace(/data-track-category=""/g, 'data-track-category="' + window.pageType + '"');
		}
		return text;
	},

	compile_html: function(_el) {
		if (_el) {
			// To compile the html to initialize the angular widget
			angular.element(document).injector().invoke(['$compile', function($compile) {
				var scope = angular.element(_el).scope();
				$compile(_el)(scope);
			}]);
		}
	},

	// polyfills
	add_polyfill_find: function() {
		// https://tc39.github.io/ecma262/#sec-array.prototype.find
		if (!Array.prototype.find) {
		  Object.defineProperty(Array.prototype, 'find', {
		    value: function(predicate) {
		     // 1. Let O be ? ToObject(this value).
		      if (this == null) {
		        throw new TypeError('"this" is null or not defined');
		      }

		      var o = Object(this);

		      // 2. Let len be ? ToLength(? Get(O, "length")).
		      var len = o.length >>> 0;

		      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
		      if (typeof predicate !== 'function') {
		        throw new TypeError('predicate must be a function');
		      }

		      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
		      var thisArg = arguments[1];

		      // 5. Let k be 0.
		      var k = 0;

		      // 6. Repeat, while k < len
		      while (k < len) {
		        // a. Let Pk be ! ToString(k).
		        // b. Let kValue be ? Get(O, Pk).
		        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
		        // d. If testResult is true, return kValue.
		        var kValue = o[k];
		        if (predicate.call(thisArg, kValue, k, o)) {
		          return kValue;
		        }
		        // e. Increase k by 1.
		        k++;
		      }

		      // 7. Return undefined.
		      return undefined;
		    },
		    configurable: true,
		    writable: true
		  });
		}
	},

	add_polyfill_closest: function() {
		if (window.Element && !Element.prototype.closest) {
		  Element.prototype.closest =
		  function(s) {
		      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
		          i,
		          el = this;
		      do {
		          i = matches.length;
		          while (--i >= 0 && matches.item(i) !== el) {};
		      } while ((i < 0) && (el = el.parentElement));
		      return el;
		  };
		}
	},

	add_videos_link: function(elem){
		if (elem) {
			let videosButton = elem.getElement('.videos-button');
			let videosLinks = elem.getElement('.videos-link');
			let links = videosLinks && videosLinks.getElements('.video-link');

			if (videosLinks) {
				if (videosButton) {
					videosButton.removeEvents('click');
					videosButton.addEvent('click', (ev) => {
						ev.stopPropagation();
						videosLinks.toggle();
					});
				}

				if (links) {
					links.addEvent('click', (ev) => {
						videosLinks.hide();
					});
				}

				document.addEvent('click', (ev) => {
					videosLinks.hide();
				});
			}
		}
	},

	get_smart_image: function(width, height, url, mode = "fit-in", format = "webp") {
		let newUrl = window.thumbor_server_cdn;
		let devicePixelRatio = 1; // window.devicePixelRatio; -- don't use devicePixelRatio since images are too large in this case
		let newWidth = width ? Math.round(devicePixelRatio * width) : '';
		let newHeight = height ? Math.round(devicePixelRatio * height) : '';

		if ((format === 'webp' && crBrowser['support.webp']) || (format && format !== 'webp')) {
			newUrl += `/${mode}/${newWidth}x${newHeight}/${format}/${url}`;
		} else {
			newUrl += `/${mode}/${newWidth}x${newHeight}/${url}`
		}

		return newUrl;
	},

	get_smart_image_fs: function(url, mode = "fit-in", format = "webp") {
		let width  = window.screen.width;
		let height = window.screen.height;
		return this.get_smart_image(width, height, url, mode, format);
	},

	init_recaptcha: function() {
		window.crRecaptcha.init();
	},

	init_cookie_notice: function() {
		var _cookie_notice = $(document.body).getElement('.cookie-notice');
		var _btn_cookie_notice = $(document.body).getElement('.cookie-notice-btn');
		if (_btn_cookie_notice) {
			_btn_cookie_notice.addEvent('click', (ev) => {
				ev.preventDefault();
				ev.stopPropagation();
				_cookie_notice.hide();

				// init cookie
				Cookie.write('cr_cookie_notice', 1, {duration: 365});
			});
		}
	},

	// Browser informations
	is_mobile_safari: function() {
		return (Browser.platform === 'ios');
	},

	is_chrome: function() {
		return (Browser.name === 'chrome');
	},

	is_safari: function() {
		return (Browser.name === 'safari');
	},

	is_firefox: function() {
		return (Browser.name === 'firefox');
	},

	is_ie: function() {
		return (Browser.name === 'ie');
	},

	is_ie8: function() {
		return (Browser.name === 'ie' && Browser.version === 8);
	},

	is_ie9: function() {
		return (Browser.name === 'ie' && Browser.version === 9);
	},

	is_ie10: function() {
		return (Browser.name === 'ie' && Browser.version === 10);
	},

	is_ie11: function() {
		return (Browser.name === 'ie' && Browser.version === 11);
	},

	is_edge: function() {
		return (Browser.name === 'edge');
	},

	is_touch_supported: function() {
		var msTouchEnabled = window.navigator.msMaxTouchPoints;
		var generalTouchEnabled = "ontouchstart" in new Element('div');

		return (msTouchEnabled || generalTouchEnabled);
	},

	stick_listing_contact_form_and_ads: function() { 
		var self = this;
		var _content_aside = document.getElement('.content_aside');
		if (!_content_aside) {
			return;
		}

		var _side_contact = document.getElement('.contact-component');
		var _sticky_content = _side_contact ? document.getElement('.sticky-content') : null;

		var stalker = document.getElement('.w_stalker');
		var contentBody1 = document.getElement('.content_body_1');
		var contentBody2 = document.getElement('.content_body_2');
		var contentAside1 = document.getElement('.content_aside_1');
		var contentAside2 = document.getElement('.content_aside_2');
		
		var stalkerHeight = (stalker ? stalker.getSize().y : 0) + 20;

		var flags1 = {
			fixOrStick: false
		};
		var flags2 = {
			fixOrStick: false
		};
		
		window.addEvents({
			'scroll' : function(e) {
				var scrollTop = window.getScrollTop();

				// scroll contact form
				if (_sticky_content) {
					var stickyPoint1 = contentAside1.querySelector('.sticky-point');
					self.scroll_content(_sticky_content, stickyPoint1, contentBody1, flags1, stalkerHeight, scrollTop, 'contactform');
				}
			}
		});
	},

	stick_listing_search_callout_ads: function() {
		var self = this;
		var rental_listings_search_results = document.getElement('.rental-listings-search-results');
		var closed_listings_search_results = document.getElement('.closed-listings-search-results');
		var calloutBoxContent = document.getElement('.content_aside_2');
		if (!!rental_listings_search_results || !!closed_listings_search_results || !calloutBoxContent) {
			self.stick_last_ads();
		}
	},

	stick_market_insight_callout_ads: function() {
		var self = this;
		var calloutBoxContent = document.getElement('.content_aside_2');
		if (!calloutBoxContent) {
			self.stick_last_ads();
		} else {
			var stalker = document.getElement('.w_stalker');
			var stickyContent = calloutBoxContent.querySelector('.sticky-content');
			var params = {
				stalkerHeight:  (!!stalker ? stalker.getSize().y : 0) + 20,
				stickyPoint: calloutBoxContent.querySelector('.sticky-point'),
				stickyContent: stickyContent,
				smallAdContent: stickyContent.querySelector('.small-ad'),
				infoAboutBuilding: document.getElement('.info-about-building'),
				subscribeFooter: document.getElement('.subscribe-footer'),
				contentMain: document.getElement('.content_main'),
				moreRentalDeals: document.getElement('._no_rental_deals'),
				fixOrStick: false
			};
		
			window.addEvents({
				'scroll' : function(e) {
					// scroll/stick callout box
					if (!!params.stickyPoint && !!params.stickyContent) {
						params.scrollTop = window.getScrollTop();
						self.scroll_market_insight_content(params);
					}
				}
			});
		}
	},

	scroll_market_insight_content: function(params) {
		var stickyPointTop = !!params.stickyPoint ? params.stickyPoint.getPosition().y - params.stalkerHeight : 0;
		var stickyContentHeight = !!params.stickyContent ? params.stickyContent.getHeight() : 0;
		var infoAboutBuildingTop = !!params.infoAboutBuilding ? params.infoAboutBuilding.getPosition().y - stickyContentHeight - params.stalkerHeight - 200 : 0;
		if (!!params.stickyContent && params.fixOrStick && params.scrollTop < stickyPointTop) {
			this.setStickyContentRelative(params);
			this.hideSmallAd(params);
			params.fixOrStick = false;
		} else if (!!params.stickyContent && params.scrollTop >= stickyPointTop && params.scrollTop < infoAboutBuildingTop) {
			this.setStickyContentFixed(params);
			this.hideSmallAd(params);
			params.fixOrStick = true;
		} else if (!!params.stickyContent && params.scrollTop >= infoAboutBuildingTop) {
			this.showSmallAd(params, '');
			if ((params.scrollTop + 850) >= params.subscribeFooter.getPosition().y) {
				var _extra = 820;
				if (!!params.moreRentalDeals) {
					_extra = 620;
				}
				var _top = params.contentMain.getHeight() - stickyContentHeight - _extra;
				this.setStickyContentAbsolute(params, _top);
			} else {
				this.setStickyContentFixed(params);
			}
			params.fixOrStick = true;
		}
	},
	hideSmallAd: function(params) {
		if (!!params.smallAdContent) {
			params.smallAdContent.setStyles({
				'display': 'none'
			});
		}
	},
	showSmallAd: function(params, marginTop) {
		if (!!params.smallAdContent) {
			if (!!marginTop) {
				params.smallAdContent.setStyles({
					'display': 'block',
					'margin-top': marginTop
				});
			} else {
				params.smallAdContent.setStyles({
					'display': 'block'
				});
			}
		}
	},
	setStickyContentFixed: function(params) {
		params.stickyContent.setStyles({
			'position' : 'fixed',
			'top' : params.stalkerHeight,
			'left' : 'auto'
		});
	},
	setStickyContentRelative: function(params) {
		params.stickyContent.setStyles({
			'position' : 'relative',
			'top' : 0,
			'left' : 'inherit'
		});
	},
	setStickyContentAbsolute: function(params, _top) {
		params.stickyContent.setStyles({
			'position': 'absolute',
			'top': _top + 'px',
		});
	},
	setBuildingSellData: function(_sell, buildingTotalUnits) {
		if (!!buildingTotalUnits && buildingTotalUnits < 40) {
			_sell.set('href', '#');
			_sell.set('data-class', 'cr-popup-open');
			_sell.set('data-popup-name', 'popup-sell');
		}
	}
});

// uncomment this when round 3 is merged
// to avoid conflicts
// if(window.Ada) {
// 	Core.extend(window.Ada);
// }

var GoogleApiLoad = false;
var Locale_is_defined = false;
var Page_on_hold = {
	active: false
};
